import { MaskedTextBox } from "@progress/kendo-react-inputs";
import styled from "styled-components";

export const enum VIEW_MODES {
    LOGIN,
    FORGET_PASSWORD,
    NEW_PASSWORD,
    REQUIRE_NEW_PASSWORD
}

export type FormValues = {
    email: string
    password?: string
    new_password?: string
    code?: string
}

export const StyledMaskedTextBox = styled(MaskedTextBox)`
    input,
    input:active,
    input:focus {
        border-color: inherit;
        outline: inherit;
        border-radius: inherit;
    }
`